import * as Login from './login'
import * as Meal from './setMeal'
import * as user from './user'

export default {
	...Login,
	...user,
	...Meal
}
